import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { analytics } from '@/lib/analytics';
import { Capacitor } from '@capacitor/core';

export const CookieConsent = () => {
  const [show, setShow] = useState(false);
  
  useEffect(() => {
    // Não mostrar em plataformas nativas (iOS/Android)
    if (Capacitor.isNativePlatform()) {
      return;
    }
    
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Delay para não aparecer imediatamente
      setTimeout(() => setShow(true), 1000);
    }
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShow(false);
    // Registrar consentimento
    analytics.featureDiscovered('cookie_consent_accepted');
  };
  
  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setShow(false);
    analytics.featureDiscovered('cookie_consent_rejected');
  };
  
  if (!show || Capacitor.isNativePlatform()) return null;
  
  return (
    <div className="fixed bottom-0 inset-x-0 z-[999] p-4 animate-slide-up">
      <Card className="max-w-4xl mx-auto p-4 shadow-elegant border-primary/20">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm sm:text-base">
              Usamos cookies para melhorar sua experiência, analisar o uso do app e personalizar conteúdo.{' '}
              <a href="/privacy" className="underline text-primary hover:text-primary/80 transition-colors">
                Saiba mais
              </a>
            </p>
          </div>
          <div className="flex gap-2 w-full sm:w-auto">
            <Button 
              variant="outline" 
              size="sm" 
              onClick={handleReject}
              className="flex-1 sm:flex-none"
            >
              Recusar
            </Button>
            <Button 
              size="sm" 
              onClick={handleAccept}
              className="flex-1 sm:flex-none"
            >
              Aceitar
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
